import React from "react";
import { dispatch } from '@rematch/core';
import { Button, Popup } from 'semantic-ui-react'
import Define from "./../../../../../images/svg/arrangementPane/icon-define.svg";
import Configure from "./../../../../../images/svg/arrangementPane/icon-configure.svg";
import Sequence from "./../../../../../images/svg/arrangementPane/icon-sequence.svg";
import Prioritize from "./../../../../../images/svg/arrangementPane/icon-prioritize.svg";
import Schedule from "./../../../../../images/svg/arrangementPane/icon-schedule.svg";
import Summary from "./../../../../../images/svg/arrangementPane/icon-summary.svg";
import Publish from "./../../../../../images/svg/arrangementPane/icon-publish.svg";
import AdditionalInformation from "./../../../../../images/svg/initiative_svg/additional_info.svg";


let icon = {
    Define: Define,
    Configure: Configure,
    Sequence: Sequence,
    Prioritize: Prioritize,
    Schedule: Schedule,
    Summary: Summary,
    AdditionalInformation: AdditionalInformation,
    Publish: Publish
}

let isAuthorizedToPublish = false;


const style = {
    borderRadius: 0,
    opacity: 0.8,
    padding: '6px'
}


class ArrangementPane extends React.Component {
    constructor(props) {
        super(props);
        this.redirectTo = this.redirectTo.bind(this);
    }

    async redirectTo(index) {
        let pathname = ""
        const { history } = this.props;
        switch (index) {
            case "Define":
                dispatch.lifeCycle.getPacksAsync({ organizationId: this.props.selectedOrganisation.id, user: this.props.user, role: this.props.selectedOrganisation.role });
                pathname = this.props.playbookPath ? `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_pb/${this.props.playbookPath.split('_pb/')[1]}` : `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_pb`;
                break;
            case "Configure":
                pathname = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_pb/steps/${this.props.selectedPracticeLibrary._id}/configure`;
                break;
            case "Sequence":
                pathname = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_pb/steps/${this.props.selectedPracticeLibrary._id}/sequence`;
                dispatch.lifeCycle.getPackAndUpdateSelectedPracticeLibary(this.props.selectedPracticeLibrary._id);
                break;
            case "Assign":
                pathname = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_pb/steps/${this.props.selectedPracticeLibrary._id}/assign`;
                // dispatch.lifeCycle.getPackAndUpdateSelectedPracticeLibary(this.props.selectedPracticeLibrary._id);
                break;
            case 'Summary':
                pathname = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_pb/steps/${this.props.selectedPracticeLibrary._id}/summary`;
                break;
            case 'Custom Attribute':
                pathname = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_pb/steps/${this.props.selectedPracticeLibrary._id}/additionalInformation`;
                break;
            case 'Swimline':
                pathname = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_pb/steps/swimlineStructure`;
                break;
            case "Publish":
                pathname = `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_pb/steps/${this.props.selectedPracticeLibrary._id}/publish`;
                dispatch.lifeCycle.getPackAndUpdateSelectedPracticeLibary(this.props.selectedPracticeLibrary._id);
                break;
        }
        history.push({ pathname: pathname });
        await dispatch.app.setCollapsedResourcePaneIndexTemp(null);
        await dispatch.lifeCycle.setArrangementPaneActiveButtonFlag(index);
        await dispatch.lifeCycle.disableLinking();
        await dispatch.lifeCycle.activePage(null);
        await dispatch.lifeCycle.showResourecePane(null);
    }

    componentWillReceiveProps() {
        isAuthorizedToPublish = false;
        this.props.selectedPracticeLibrary && this.props.selectedPracticeLibrary.participants && this.props.selectedPracticeLibrary.participants.map(participant => {
            if ((this.props.user._id === participant.accountUserId && participant.role === 'author') || (this.props.user._id === participant.accountUserId && participant.role === 'contributor')) {
                isAuthorizedToPublish = true;
            }
        });
    }
    mouseEnter(name) {
        dispatch.app.setHelpContext(name);
    }
    render() {
        const showPublishOption = () => {
            if ((this.props.selectedPracticeLibrary.status !== 4 && this.props.selectedPracticeLibrary.status !== 5) && !(this.props.selectedPracticeLibrary.status === 1 && isAuthorizedToPublish)) {
                return (
                    <Button
                        onMouseEnter={() => this.mouseEnter("Publish")}
                        className={this.props.arrangementPaneActiveButtonFlag === "Publish" ? "button active" : "button"}

                        onClick={(e) => { this.redirectTo("Publish") }}
                    >
                        <img src={icon.Publish} alt="Publish" />
                    </Button>
                )
            }

        }

        const buttonMenu = [
            { name: "Define", icon: "th large", status: 0 },
            { name: "Configure", icon: "th list", status: 1 },
            { name: "Sequence", icon: "sitemap", status: 2 },
            { name: "Assign", icon: "group", status: 3 },
            { name: "Summary", icon: "group", status: 4 },
            { name: "Custom Attribute", icon: "list ol", status: 6 },
            // { name: "Schedule", icon: "random", status: 4 },
        ]
        return (
            <div className="arrangementPane" style={{ height: (this.props.componentDesignerDimension.windowHeight - 50) - this.props.componentDesignerDimension.height }}>
                <Button.Group vertical>
                    {buttonMenu.map((item, index) => {
                        return <Popup
                            key={index}
                            trigger={<Button
                                key={index}
                                onMouseEnter={() => this.mouseEnter(item.name)}
                                className={this.props.setPage === item.name ? "button active" : "button"}

                                onClick={(e) => { this.redirectTo(item.name) }}><img alt="Action Icon"
                                    src={
                                        item.name === 'Define' ? icon.Define :
                                            item.name === 'Configure' ? icon.Configure :
                                                item.name === 'Sequence' ? icon.Sequence :
                                                    item.name === 'Assign' ? icon.Prioritize :
                                                        item.name === 'Summary' ? icon.Summary :
                                                            item.name === 'Schedule' ? icon.Schedule :
                                                                item.name === 'Custom Attribute' ? icon.AdditionalInformation : ""}
                                /></Button>}
                            content={item.name}
                            position='left center'
                            style={style}
                            inverted
                        />
                    })}
                    <Popup
                        trigger={showPublishOption()}
                        content='Publish'
                        position='left center'
                        style={style}
                        inverted
                    />
                </Button.Group>
            </div>
        );
    }
}
export default ArrangementPane;
